<template>
    <main class="d-flex flex-column min-h-100vh">
        <header class="header">
            <DemoBar/>
            <top-nav :url="url()" :guest="true"></top-nav>
        </header>
        <article class="d-flex flex-1-custom">
            <div class="container">
                <div class="row my-5">
                    <div class="col-12 col-md-10 col-lg-7 mx-auto text-center">
                        <h1 class="login-title font-poppins font-weight-light color-light-blue">
                            {{ pageTitle }}</h1>
                    </div>
                </div>
                <slot/>
                <div class="row">
                    <div class="col-10 col-md-7 my-5 mx-auto text-center">
                        <a :href="$page.props.config.dlr_website" class="font-poppins font-weight-medium color-dark-blue"
                           target="_blank">
                            <u>{{ Lang.get('employeedashboard::shared.clean_layout.what_is_de_leerrekening') }}</u>
                        </a>
                    </div>
                </div>
            </div>
        </article>
    </main>
</template>

<script>
import DemoBar from '@/Shared/DemoBar';
import TopNav from "@/Shared/TopNav";

export default {

    components: {
        DemoBar,
        TopNav,
    },

    props: {
        title: {
            type: String,
            default() {
                return 'DeLeerrekening';
            }
        },

        pageTitle: {
            type: String,
            default: null
        }
    },

    watch: {
        title: {
            immediate: true,
            handler(title) {
                document.title = title
            },
        },
    },

    methods: {
        url() {
            return location.href;
        },
    },

    mounted () {
        document.body.classList.add('employee-login')
        document.body.classList.add('background-company')
    },

    destroyed () {
        document.body.classList.remove('employee-login')
        document.body.classList.remove('background-company')
    }
}
</script>
